module.exports = __webpack_public_path__ + "static/media/gf.23d8b419.svg";